import { createSlice } from "@reduxjs/toolkit";
import { adminSendEmailVerification } from "./thunk";

const initialState = {
    loading: false,
    error: null as string | null,
    success: false,
    data: null as { success: boolean; message?: any; data: any } | null
};

const adminEmailVerificationSlice = createSlice({
    name: "adminEmailVerification",
    initialState,
    reducers: {
        clearAdminEmailVerificationState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.data = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(adminSendEmailVerification.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        });
        builder.addCase(adminSendEmailVerification.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(adminSendEmailVerification.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
            state.success = false;
        });
    }
});

export const { clearAdminEmailVerificationState } = adminEmailVerificationSlice.actions;
export default adminEmailVerificationSlice.reducer;
